const urlsService = {
    basepath: {
        // ip: process.env.VUE_APP_BACKEND_HOST,
        // port: process.env.VUE_APP_BACKEND_PORT,
        ip: process.env.VUE_APP_BACKEND_HOST === undefined ? window.location.protocol + "//" + window.location.host + "/backend" : process.env.VUE_APP_BACKEND_HOST,
        port: process.env.VUE_APP_BACKEND_PORT === undefined ? "" : process.env.VUE_APP_BACKEND_PORT,
        apiVersion: "/api/v2",
        apiSwagger: "/v2",
        apiSuperAdmin: "/api",
        apiPublic: "/api/public",
        apiRadar: "/api/v1/radar"

    },
    modules: {
        login: {
            login: "/login",
        },
        dialogs: {
            ask: "/ask",
            advancedAsk: "/ask/advanced",
            intentOperation: "/intent",
            getQRCode: "/telegram-qrcode",
        },
        documents: {
            semanticsearch: '/semanticsearch',
            upload: "/upload",
            bulk: "/upload/bulk",
            getFile: "/file",
            getFileDownload: "/file/download",
            deleteFile: "/file/delete",
        },
        email: {
            sendEmail: "/sendEmail",
            getEmails: "/getEmails",
            saveEmails: "/saveEmails",
            deleteEmail: "/deleteEmail",
            resetEmail: "/resetEmail",
            searchAllEmails: "/searchEmails",
        },
        synonyms: {
            uploadSynonyms: "/uploadalias",
            getSynonyms: "/getaliasfile",
        },
        integrations: {
            integrationService: "/integrationService"
        },
        plugins: {
            plugins: "/plugins",
            linkIntentPlugin: "/linkIntentPlugin"
        },
        docs: {
            api: '/api-docs'
        },
        voice: {
            speechToText: '/speechToText'
        },
        innovation: {
            uploadStartups: "/innovation/uploadFile",
            uploadExcel: "/innovation/uploadExcel",
            uploadStartupsJson: "/innovation/uploadFileJson",
            searchStartupByChallenge: "/innovation/searchStartupByChallenge",
            getFileStartupRegisteredToChallenge: "/innovation/getFileStartupRegisteredToChallenge",
            getStartup: "/innovation/getStartups",
            getPaginatedStartupsByApprovalStatus: "/innovation/getPaginatedStartupsByApprovalStatus",
            findStartups: "/innovation/findStartups",
            getStartupsRegisteredToChallenge: "/innovation/getStartupsRegisteredToChallenge",
            getTagsSuggestion:"/getTagsSuggestion",
            getAreaVerticalMapping:"/getAreaVerticalMapping",
            getChallenge: "/innovation/getChallenge",
            getChallenges: "/innovation/getChallenges",
            registerStartup: "/innovation/registerStartup",
            registerToChallenge: "/innovation/registerToChallenge",
            searchStartup:"/innovation/search",
            createStartup:"/innovation/createStartup",
            updateStartup:"/innovation/updateStartup",
            deleteStartup:"/innovation/deleteStartup",
            synonymsOperation:"/innovation/synonymsOperation",
            chatHistory:"/innovation/chatHistory",
            userSettings:"/innovation/userSettings",
            getStartupResults: "/innovation/getStartupResults",
            getStartupById: "/innovation/getStartupById",
            getChallengesPubNotExp: "/innovation/getChallengesPubNotExp",
            getChallengesNotPubExp: "/innovation/getChallengesNotPubExp",
            getChallengesPubExp: "/innovation/getChallengesPubExp",
            getChallengesNotPubNotExp: "/innovation/getChallengesNotPubNotExp",

            getNewsNotPubNotToApp: "/innovation/getNewsNotPubNotToApp",
            getNewsPubNotToApp: "/innovation/getNewsPubNotToApp",
            getNewsNotPubToApp: "/innovation/getNewsNotPubToApp",
            newsOperation: "/innovation/newsOperation",
            getNewsPublic: "/innovation/getNews",
            getNewsById: "/innovation/getNewsById",

            getOnBoarding: "/innovation/getOnBoarding",

            getStartupToContactByChallenge: "/innovation/getStartupToContactByChallenge",

            challengeOperation: "/innovation/challengeOperation",
            vertical: "/innovation/vertical",
            opco: "/innovation/opco",
            market: "/innovation/market",
            startupOperationProposal: "/innovation/startupOperationProposal",
            approveOperation: "/innovation/approveOperation",
            operationsHistory: "/innovation/operationsHistory",
            startupModificationProposal: "/innovation/startupModificationProposal",
            getStartupPublic: "/innovation/getStartup",
            updateStartupAuth: "/innovation/updateStartupAuth",
            challengesGhost: "/innovation/challengesGhost",
            contactsGhost: "/innovation/ghostContacts",
            tagsOperation: "/innovation/tagsOperation",
            createTrend: "/trends/create/",
            updateTrend: "/trends/update/",
            trendArxivEstimate: "/trends/check_details",
            deleteTrend: "/trends/delete/",
            getTrend: "/trends",
            searchTrendDocs: "/trends/search",
            getTrendHistory: "/trends/history",
            getStartupNamesByTrend: "/trends/startup/",
            getTechTrend: "/getTechTrend",
            getTechTrendbyCategorybyName: "/innovation/getTechTrendbyCategorybyName",
            getTechTrendNames: "/innovation/getTechTrendNames",
            getlastReview: '/innovation/getlastReview',
            getAllReviews: '/innovation/getAllReviews',
            getuploadReviews: '/innovation/uploadReviews',
            getAverageRating: '/innovation/getAverageRating'
        },
        superadmin: {
            createUser: "/admin/user",
            groups: "/admin/group"
        }
    },
};

// *************** BASE
function getBaseUrl() {
    let ip = urlsService.basepath.ip;
    let port = urlsService.basepath.port;


    let portSeparator = ":";
    if (port === "") {
        portSeparator = "";
    }
    return ip + portSeparator + port + urlsService.basepath.apiVersion;
}

function getBaseUrlSwagger() {
    let ip = urlsService.basepath.ip;
    let port = urlsService.basepath.port;


    let portSeparator = ":";
    if (port === "") {
        portSeparator = "";
    }
    return ip + portSeparator + port + urlsService.basepath.apiSwagger;
}

function getBaseUrlSuperAdmin() {
    let ip = urlsService.basepath.ip;
    let port = urlsService.basepath.port;


    let portSeparator = ":";
    if (port === "") {
        portSeparator = "";
    }
    return ip + portSeparator + port + urlsService.basepath.apiSuperAdmin;
}

function getBaseUrlPublic() {
    let ip = urlsService.basepath.ip;
    let port = urlsService.basepath.port;


    let portSeparator = ":";
    if (port === "") {
        portSeparator = "";
    }
    return ip + portSeparator + port + urlsService.basepath.apiPublic;
}
function getBaseUrlRadar() {
    let ip = urlsService.basepath.ip;
    let port = urlsService.basepath.port;


    let portSeparator = ":";
    if (port === "") {
        portSeparator = "";
    }
    return ip + portSeparator + port + urlsService.basepath.apiRadar;
}

// *************** LOGIN
function doLogin() {
    return getBaseUrl() + urlsService.modules.login.login;
}

// *************** DIALOGS
function doAsk() {
    return getBaseUrl() + urlsService.modules.dialogs.ask;
}

function doAdvancedAsk() {
    return getBaseUrl() + urlsService.modules.dialogs.advancedAsk;
}

function doIntentOperation() {
    return getBaseUrl() + urlsService.modules.dialogs.intentOperation;
}

function getQRCode() {
    return getBaseUrl() + urlsService.modules.dialogs.getQRCode;
}


// *************** DOCUMENTS


function semanticSearchDocuments() {
    return getBaseUrl() + urlsService.modules.documents.semanticsearch;
}

function uploadDocument() {
    return getBaseUrl() + urlsService.modules.documents.upload;
}

function uploadBulk() {
    return getBaseUrl() + urlsService.modules.documents.bulk;
}


function getFile() {
    return getBaseUrl() + urlsService.modules.documents.getFile;
}

function getFileDownload() {
    return getBaseUrl() + urlsService.modules.documents.getFileDownload;
}

function deleteFile() {
    return getBaseUrl() + urlsService.modules.documents.deleteFile;
}



// *************** EMAIL
function getEmails() {
    return getBaseUrl() + urlsService.modules.email.getEmails;
}

function sendEmail() {
    return getBaseUrl() + urlsService.modules.email.sendEmail;
}

function deleteEmail() {
    return getBaseUrl() + urlsService.modules.email.deleteEmail;
}

function saveEmails() {
    return getBaseUrl() + urlsService.modules.email.saveEmails;
}

function resetEmail() {
    return getBaseUrl() + urlsService.modules.email.resetEmail;
}

function searchAllEmails() {
    return getBaseUrl() + urlsService.modules.email.searchAllEmails;
}



// *************** SYNONYMS
function uploadSynonyms() {
    return getBaseUrl() + urlsService.modules.synonyms.uploadSynonyms;
}

function getSynonyms() {
    return getBaseUrl() + urlsService.modules.synonyms.getSynonyms;
}


function getIntegrationService() {
    return getBaseUrl() + urlsService.modules.integrations.integrationService;
}

function plugins() {
    return getBaseUrl() + urlsService.modules.plugins.plugins;
}

function linkIntentPlugin() {
    return getBaseUrl() + urlsService.modules.plugins.linkIntentPlugin;
}

function getAPIDocs() {
    return getBaseUrlSwagger() + urlsService.modules.docs.api;
}

function speechToText() {
    return getBaseUrl() + urlsService.modules.voice.speechToText;
}

// ************** INNOVATION ******
function uploadStartups() {
    return getBaseUrl() + urlsService.modules.innovation.uploadStartups;
}

function uploadExcel(){
    return getBaseUrl() + urlsService.modules.innovation.uploadExcel;
}

function uploadStartupsJson() {
    return getBaseUrl() + urlsService.modules.innovation.uploadStartupsJson;
}
function chatHistory() {
    return getBaseUrl() + urlsService.modules.innovation.chatHistory;
}

function getStartupToContactByChallenge() {
    return getBaseUrl() + urlsService.modules.innovation.getStartupToContactByChallenge;
}

function searchStartupByChallenge() {
    return getBaseUrl() + urlsService.modules.innovation.searchStartupByChallenge;
}

function searchStartup() {
    return getBaseUrl() + urlsService.modules.innovation.searchStartup;
}

function getFileStartupRegisteredToChallenge() {
    return getBaseUrl() + urlsService.modules.innovation.getFileStartupRegisteredToChallenge;
}

function getStartupsRegisteredToChallenge() {
    return getBaseUrl() + urlsService.modules.innovation.getStartupsRegisteredToChallenge;
}

function getStartups() {
    return getBaseUrl() + urlsService.modules.innovation.getStartup;
}

function getPaginatedStartupsByApprovalStatus() {
    return getBaseUrl() + urlsService.modules.innovation.getPaginatedStartupsByApprovalStatus;
}

function findStartups() {
    return getBaseUrl() + urlsService.modules.innovation.findStartups;
}

function createStartup() {
    return getBaseUrl() + urlsService.modules.innovation.createStartup;
}

function updateStartup() {
    return getBaseUrl() + urlsService.modules.innovation.updateStartup;
}

function deleteStartup() {
    return getBaseUrl() + urlsService.modules.innovation.deleteStartup;
}

function synonymsOperation() {
    return getBaseUrl() + urlsService.modules.innovation.synonymsOperation;
}

function userSettings() {
    return getBaseUrl() + urlsService.modules.innovation.userSettings;
}

function getStartupResults() {
    return getBaseUrl() + urlsService.modules.innovation.getStartupResults;
}

function getNewsNotPubNotToApp() {
    return getBaseUrl() + urlsService.modules.innovation.getNewsNotPubNotToApp;
}
function getNewsPubNotToApp() {
    return getBaseUrl() + urlsService.modules.innovation.getNewsPubNotToApp;
}
function getNewsNotPubToApp() {
    return getBaseUrl() + urlsService.modules.innovation.getNewsNotPubToApp;
}
function newsOperation() {
    return getBaseUrl() + urlsService.modules.innovation.newsOperation;
}
function getNewsPublic() {
    return getBaseUrlPublic() + urlsService.modules.innovation.getNewsPublic;
}
function getNewsById() {
    return getBaseUrlPublic() + urlsService.modules.innovation.getNewsById;
}

function getOnBoarding() {
    return getBaseUrlPublic() + urlsService.modules.innovation.getOnBoarding;
}

function getChallengesPubNotExp() {
    return getBaseUrl() + urlsService.modules.innovation.getChallengesPubNotExp;
}

function getChallengesNotPubNotExp() {
    return getBaseUrl() + urlsService.modules.innovation.getChallengesNotPubNotExp;
}

function getChallengesPubExp() {
    return getBaseUrl() + urlsService.modules.innovation.getChallengesPubExp;
}

function getChallengesNotPubExp() {
    return getBaseUrl() + urlsService.modules.innovation.getChallengesNotPubExp;
}

function challengeOperation() {
    return getBaseUrl() + urlsService.modules.innovation.challengeOperation;
}

function challengesGhost() {
    return getBaseUrl() + urlsService.modules.innovation.challengesGhost;
}

function vertical() {
    return getBaseUrl() + urlsService.modules.innovation.vertical;
}
function opco() {
    return getBaseUrl() + urlsService.modules.innovation.opco;
}
function market() {
    return getBaseUrl() + urlsService.modules.innovation.market;
}

function startupOperationProposal() {
    return getBaseUrl() + urlsService.modules.innovation.startupOperationProposal;
}

function approveOperation() {
    return getBaseUrl() + urlsService.modules.innovation.approveOperation;
}
function operationsHistory() {
    return getBaseUrl() + urlsService.modules.innovation.operationsHistory;
}

function contactsGhost() {
    return getBaseUrl() + urlsService.modules.innovation.contactsGhost;
}

function tagsOperation() {
    return getBaseUrl() + urlsService.modules.innovation.tagsOperation;
}

function getChallengesPublic() {
    return getBaseUrlPublic() + urlsService.modules.innovation.getChallenges;
}

function getChallengePublic() {
    return getBaseUrlPublic() + urlsService.modules.innovation.getChallenge;
}

function registerStartupPublic() {
    return getBaseUrlPublic() + urlsService.modules.innovation.registerStartup;
}

function registerToChallengePublic() {
    return getBaseUrlPublic() + urlsService.modules.innovation.registerToChallenge;
}

function startupModificationProposal() {
    return getBaseUrlPublic() + urlsService.modules.innovation.startupModificationProposal;
}

function getStartupPublic() {
    return getBaseUrlPublic() + urlsService.modules.innovation.getStartupPublic;
}

function updateStartupAuthPublic() {
    return getBaseUrlPublic() + urlsService.modules.innovation.updateStartupAuth;
}


// ************** SUPERADMIN ******
function createUser() {
    return getBaseUrlSuperAdmin() + urlsService.modules.superadmin.createUser;
}

function groups() {
    return getBaseUrlSuperAdmin() + urlsService.modules.superadmin.groups;
}

function getStartupById() {
    return getBaseUrl() + urlsService.modules.innovation.getStartupById;
}

function getTagsSuggestion() {
    return getBaseUrlPublic() + urlsService.modules.innovation.getTagsSuggestion;
}

function getTechTrend(){
    return getBaseUrlPublic() + urlsService.modules.innovation.getTechTrend;
}
function getTechTrendbyCategorybyName(){
    return getBaseUrlPublic() + urlsService.modules.innovation.getTechTrendbyCategorybyName;
}

function getTechTrendNames(){
    return getBaseUrlPublic() + urlsService.modules.innovation.getTechTrendNames;
}

function getlastReview(){
    return getBaseUrlPublic() + urlsService.modules.innovation.getlastReview;
}

function getAverageRating(){
    return getBaseUrlPublic() + urlsService.modules.innovation.getAverageRating;
}

function getAllReviews(){
    return getBaseUrlPublic() + urlsService.modules.innovation.getAllReviews;
}

function uploadReviews(){
    return getBaseUrlPublic() + urlsService.modules.innovation.getuploadReviews;
}

function getAreaVerticalMapping() {
    return getBaseUrlPublic() + urlsService.modules.innovation.getAreaVerticalMapping;
}

function getTrends() {
    return getBaseUrlRadar() + urlsService.modules.innovation.getTrend;
}

function searchTrendDocs() {
    return getBaseUrlRadar() + urlsService.modules.innovation.searchTrendDocs;
}

function getTrendHistory() {
    return getBaseUrlRadar() + urlsService.modules.innovation.getTrendHistory;
}

function deleteTrend(){
    return getBaseUrlRadar() + urlsService.modules.innovation.deleteTrend;
}

function createTrend(){
    return getBaseUrlRadar() + urlsService.modules.innovation.createTrend;
}

function updateTrend(){
    return getBaseUrlRadar() + urlsService.modules.innovation.updateTrend;
}

function estimateDocsTrend(){
    return getBaseUrlRadar() + urlsService.modules.innovation.trendArxivEstimate;
}
function getStartupNamesByTrend(){
    return getBaseUrlRadar() + urlsService.modules.innovation.getStartupNamesByTrend;
}

export default {
    name: "Urls",
    doLogin: doLogin(),
    doAsk: doAsk(),
    doAdvancedAsk: doAdvancedAsk(),
    doIntentOperation: doIntentOperation(),
    semanticSearchDocuments: semanticSearchDocuments(),
    uploadDocument: uploadDocument(),
    getFile: getFile(),
    getFileDownload: getFileDownload(),
    deleteFile: deleteFile(),
    sendEmail: sendEmail(),
    saveEmails: saveEmails(),
    deleteEmail: deleteEmail(),
    getEmails: getEmails(),
    resetEmail: resetEmail(),
    searchAllEmails: searchAllEmails(),
    uploadSynonyms: uploadSynonyms(),
    getSynonyms: getSynonyms(),
    getIntegrationService: getIntegrationService(),
    plugins: plugins(),
    linkIntentPlugin: linkIntentPlugin(),
    getAPIDocs: getAPIDocs(),
    speechToText: speechToText(),
    getQRCode: getQRCode(),
    bulk: uploadBulk(),
    uploadStartups: uploadStartups(),
    uploadExcel: uploadExcel(),
    uploadStartupsJson: uploadStartupsJson(),
    searchStartupByChallenge: searchStartupByChallenge(),

    getStartupToContactByChallenge: getStartupToContactByChallenge(),

    searchStartup: searchStartup(),
    getFileStartupRegisteredToChallenge: getFileStartupRegisteredToChallenge(),
    getStartupsRegisteredToChallenge: getStartupsRegisteredToChallenge(),
    getStartups: getStartups(),
    getPaginatedStartupsByApprovalStatus: getPaginatedStartupsByApprovalStatus(),
    findStartups: findStartups(),
    getTagsSuggestion:getTagsSuggestion(),
    getAreaVerticalMapping:getAreaVerticalMapping(),
    createStartup: createStartup(),
    updateStartup: updateStartup(),
    deleteStartup: deleteStartup(),
    synonymsOperation:synonymsOperation(),
    user: createUser(),
    getChallengePublic: getChallengePublic(),
    getChallengesPublic: getChallengesPublic(),
    registerStartupPublic: registerStartupPublic(),
    registerToChallengePublic: registerToChallengePublic(),
    chatHistory: chatHistory(),
    userSettings: userSettings(),
    getStartupResults: getStartupResults(),
    getStartupById: getStartupById(),
    getChallengesNotPubExp: getChallengesNotPubExp(),
    getChallengesNotPubNotExp: getChallengesNotPubNotExp(),
    getChallengesPubExp: getChallengesPubExp(),
    getChallengesPubNotExp: getChallengesPubNotExp(),
    challengeOperation: challengeOperation(),
    groups: groups(),
    vertical: vertical(),
    opco:opco(),
    market:market(),
    startupOperationProposal: startupOperationProposal(),
    approveOperation: approveOperation(),
    operationsHistory: operationsHistory(),
    startupModificationProposal: startupModificationProposal(),
    getStartupPublic: getStartupPublic(),
    updateStartupAuth: updateStartupAuthPublic(),
    challengesGhost: challengesGhost(),
    contactsGhost: contactsGhost(),
    tagsOperation: tagsOperation(),
    getTrends: getTrends(),
    deleteTrend: deleteTrend(),
    searchTrendDocs: searchTrendDocs(),
    getTrendHistory: getTrendHistory(),
    createTrend: createTrend(),
    updateTrend: updateTrend(),
    estimateDocsTrend: estimateDocsTrend(),
    startupNamesByTrend: getStartupNamesByTrend(),
    getNewsNotPubNotToApp: getNewsNotPubNotToApp(),
    getNewsPubNotToApp: getNewsPubNotToApp(),
    getNewsNotPubToApp: getNewsNotPubToApp(),
    newsOperation: newsOperation(),
    getNewsPublic: getNewsPublic(),
    getNewsById: getNewsById(),
    getOnBoarding: getOnBoarding(),
    getTechTrend: getTechTrend(),
    getTechTrendbyCategorybyName : getTechTrendbyCategorybyName(),
    getTechTrendNames: getTechTrendNames(),
    getlastReview: getlastReview(),
    getAllReviews: getAllReviews(),
    uploadReviews: uploadReviews(),
    getAverageRating: getAverageRating()
};
